"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Button_1 = require("../Button");
var CloseButton_1 = require("../CloseButton");
var CLASS_NAME = 'i-onboarding__popover';
var OnboardingPopover = /** @class */ (function (_super) {
    __extends(OnboardingPopover, _super);
    function OnboardingPopover() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OnboardingPopover.prototype.render = function () {
        var isLastStep = this.props.stepIndex >= this.props.stepCount - 1;
        return (React.createElement("div", { className: classNames(CLASS_NAME, 'popover', {
                'bs-popover-auto': this.props.arrow,
            }), ref: this.props.instance, role: "alert" },
            this.props.arrow && React.createElement("div", { className: "arrow", "x-arrow": "" }),
            React.createElement(CloseButton_1.CloseButton, { label: this.props.closeLabel, onClick: this.props.onDismiss }),
            this.props.stepCount > 1 && (React.createElement("div", { className: CLASS_NAME + "__progress" }, (this.props.stepIndex || 0) + 1 + " / " + this.props.stepCount)),
            React.createElement("main", null,
                React.createElement("h1", { className: CLASS_NAME + "__heading" }, this.props.heading),
                React.createElement("div", { className: CLASS_NAME + "__body" }, this.props.message),
                React.createElement("div", { className: CLASS_NAME + "__actions" },
                    React.createElement(Button_1.Button, { className: CLASS_NAME + "__actions__button", label: isLastStep
                            ? this.props.endLabel
                            : this.props.nextLabel, mode: isLastStep
                            ? Button_1.Button.Mode.Secondary
                            : Button_1.Button.Mode.Primary, onClick: isLastStep
                            ? this.props.onEnd
                            : this.props.onNext })))));
    };
    return OnboardingPopover;
}(React.Component));
exports.OnboardingPopover = OnboardingPopover;
//# sourceMappingURL=OnboardingPopover.js.map